import { http } from '@frontend/fetch';
import { SearchAuditEventsRequest, SearchAuditEventsResponse } from './types';

export const searchAuditEvents = (req: SearchAuditEventsRequest): Promise<SearchAuditEventsResponse> => {
  return http.post<SearchAuditEventsResponse>('/phone/audits/v1/audit-events:searchAuditEvents', req);
};
